var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigbusiness2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6720)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 119.593,
    x2: 17.9658,
    y2: -21.9222,
    stroke: "url(#paint0_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 119.593,
    x2: 52.9658,
    y2: -21.9222,
    stroke: "url(#paint1_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 119.593,
    x2: 88.9658,
    y2: -21.9222,
    stroke: "url(#paint2_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 119.593,
    x2: 124.966,
    y2: -21.9222,
    stroke: "url(#paint3_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 119.593,
    x2: 160.966,
    y2: -21.9222,
    stroke: "url(#paint4_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 119.593,
    x2: 195.966,
    y2: -21.9222,
    stroke: "url(#paint5_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 119.593,
    x2: 231.966,
    y2: -21.9223,
    stroke: "url(#paint6_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.4539,
    x2: 258.387,
    y2: 18.4538,
    stroke: "url(#paint7_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.4539,
    x2: 258.387,
    y2: 77.4538,
    stroke: "url(#paint8_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.4539,
    x2: 258.387,
    y2: 47.4538,
    stroke: "url(#paint9_linear_75_6720)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_6720)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_75_6720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4655 58.639L69.9392 47.8146C69.8264 45.3051 67.834 43.3574 65.4281 43.3574H54.0374C51.6315 43.3574 49.6767 45.3051 49.5263 47.8146L49 58.639C49 58.7888 49 58.9012 49 59.051L49.6015 76.093C49.6767 78.6025 51.6691 80.625 54.1126 80.625H65.3905C67.7964 80.625 69.7888 78.6399 69.9016 76.093L70.5031 59.051C70.4655 58.9386 70.4655 58.7888 70.4655 58.639ZM51.9322 60.3994C51.9322 60.0997 52.1954 59.8376 52.4961 59.8376H55.7667C56.0675 59.8376 56.3306 60.0997 56.3306 60.3994V63.658C56.3306 63.9576 56.0675 64.2198 55.7667 64.2198H52.4961C52.1954 64.2198 51.9322 63.9576 51.9322 63.658V60.3994ZM51.9322 65.718C51.9322 65.4183 52.1954 65.1562 52.4961 65.1562H55.7667C56.0675 65.1562 56.3306 65.4183 56.3306 65.718V68.9766C56.3306 69.2762 56.0675 69.5384 55.7667 69.5384H52.4961C52.1954 69.5384 51.9322 69.2762 51.9322 68.9766V65.718ZM51.9322 73.134V71.2613C51.9322 70.8493 52.2706 70.5122 52.6841 70.5122H61.1801C61.5936 70.5122 61.9319 70.8493 61.9319 71.2613V73.134C61.9319 73.546 61.5936 73.8831 61.1801 73.8831H52.6841C52.2706 73.8831 51.9322 73.546 51.9322 73.134ZM58.0975 65.1562H61.368C61.6688 65.1562 61.9319 65.4183 61.9319 65.718V68.9766C61.9319 69.2762 61.6688 69.5384 61.368 69.5384H58.0975C57.7967 69.5384 57.5336 69.2762 57.5336 68.9766V65.718C57.5336 65.4183 57.7967 65.1562 58.0975 65.1562ZM57.5336 63.658V60.3994C57.5336 60.0997 57.7967 59.8376 58.0975 59.8376H61.368C61.6688 59.8376 61.9319 60.0997 61.9319 60.3994V63.658C61.9319 63.9576 61.6688 64.2198 61.368 64.2198H58.0975C57.7967 64.2198 57.5336 63.9576 57.5336 63.658ZM66.7814 77.6661H53.0224C52.8345 77.6661 52.6465 77.5912 52.4961 77.4414C52.3458 77.2915 52.2706 77.1043 52.2706 76.917C52.2706 76.505 52.6089 76.1679 53.0224 76.1679H66.7814C67.007 76.1679 67.1949 76.2428 67.3077 76.3926C67.4581 76.5424 67.5333 76.7297 67.5333 76.917C67.5333 77.329 67.1949 77.6661 66.7814 77.6661ZM67.5333 73.3588C67.5333 73.621 67.3077 73.8457 67.0446 73.8457H63.6236C63.3605 73.8457 63.1349 73.621 63.1349 73.3588V70.9991C63.1349 70.7369 63.3605 70.5122 63.6236 70.5122H67.0446C67.3077 70.5122 67.5333 70.7369 67.5333 70.9991V73.3588ZM67.5333 69.014C67.5333 69.3136 67.2701 69.5758 66.9694 69.5758H63.6612C63.3605 69.5758 63.0973 69.3136 63.0973 69.014V65.718C63.0973 65.4183 63.3605 65.1562 63.6612 65.1562H66.9318C67.2325 65.1562 67.4957 65.4183 67.4957 65.718V69.014H67.5333ZM67.5333 63.658C67.5333 63.9576 67.2701 64.2198 66.9694 64.2198H63.6612C63.3605 64.2198 63.0973 63.9576 63.0973 63.658V60.3994C63.0973 60.0997 63.3605 59.8376 63.6612 59.8376H66.9318C67.2325 59.8376 67.4957 60.0997 67.4957 60.3994V63.658H67.5333ZM67.5333 56.3543C67.5333 56.6914 67.2325 56.991 66.8942 56.991H52.5713C52.233 56.991 51.9322 56.6914 51.9322 56.3543V47.8895C51.9322 47.5524 52.233 47.2527 52.5713 47.2527H66.8942C67.2325 47.2527 67.5333 47.5524 67.5333 47.8895V56.3543Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8036 40.2486V43.3949H53.6611V40.2486C53.6611 39.6494 54.1498 39.125 54.7889 39.125H64.7134C65.3149 39.125 65.8036 39.6119 65.8036 40.2486Z",
    fill: "#A4D143"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 185.125V179.12H28.6794V176.977H19.527V172.334H29.0143V170.169H17.1161V185.125H19.527ZM33.2173 185.125V178.897C33.2173 176.91 33.9986 175.861 35.896 175.861C37.5479 175.861 38.2176 176.598 38.2176 178.183V179.165H40.6062V177.714C40.6062 175.615 39.5123 173.807 36.9898 173.807C34.7129 173.807 33.5075 175.236 33.1726 177.022H33.0164V174.03H30.8064V185.125H33.2173ZM47.7012 185.348C51.005 185.348 53.3266 183.719 53.3266 181.352V181.152H50.9157V181.33C50.9157 182.647 49.9558 183.406 47.6342 183.406C45.0671 183.406 44.0179 182.268 43.9286 180.125H53.3489C53.4159 179.79 53.4382 179.477 53.4382 179.075C53.4382 175.705 51.0943 173.807 47.6566 173.807C44.0402 173.807 41.674 176.129 41.674 179.589C41.674 183.295 44.0626 185.348 47.7012 185.348ZM47.6119 175.705C49.9781 175.705 51.1613 176.687 51.1613 178.741V178.785H43.9509C44.0849 176.799 45.1564 175.705 47.6119 175.705ZM60.8247 185.348C64.1284 185.348 66.45 183.719 66.45 181.352V181.152H64.0392V181.33C64.0392 182.647 63.0793 183.406 60.7577 183.406C58.1905 183.406 57.1414 182.268 57.0521 180.125H66.4724C66.5393 179.79 66.5617 179.477 66.5617 179.075C66.5617 175.705 64.2177 173.807 60.78 173.807C57.1637 173.807 54.7975 176.129 54.7975 179.589C54.7975 183.295 57.186 185.348 60.8247 185.348ZM60.7354 175.705C63.1016 175.705 64.2847 176.687 64.2847 178.741V178.785H57.0744C57.2083 176.799 58.2798 175.705 60.7354 175.705ZM74.5932 188.92V182H74.6825C75.129 184.031 76.7362 185.348 79.2364 185.348C82.6964 185.348 84.5939 183.027 84.5939 179.589C84.5939 176.151 82.6518 173.807 79.2141 173.807C76.6023 173.807 75.0397 175.057 74.5932 177.111H74.3923V174.03H72.1823V188.92H74.5932ZM74.5932 179.767V179.567C74.5932 177.178 75.9772 176.017 78.4551 176.017C80.7767 176.017 82.183 176.91 82.183 179.589C82.183 182.245 80.799 183.161 78.4104 183.161C76.0442 183.161 74.5932 182.044 74.5932 179.767ZM91.935 185.348C95.6406 185.348 98.1185 183.004 98.1185 179.589C98.1185 176.129 95.6406 173.807 91.935 173.807C88.2517 173.807 85.7739 176.129 85.7739 179.589C85.7739 183.004 88.2517 185.348 91.935 185.348ZM91.935 183.205C89.2562 183.205 88.1401 181.933 88.1401 179.589C88.1401 177.223 89.2562 175.928 91.935 175.928C94.6361 175.928 95.7522 177.223 95.7522 179.589C95.7522 181.933 94.6361 183.205 91.935 183.205ZM102.279 172.736V170.169H99.868V172.736H102.279ZM102.279 185.125V174.03H99.868V185.125H102.279ZM106.922 185.125V179.634C106.922 177.223 108.016 175.973 110.449 175.973C112.749 175.973 113.686 177.022 113.686 179.098V185.125H116.097V178.45C116.097 175.883 114.579 173.807 111.498 173.807C108.686 173.807 107.212 175.593 106.878 177.468H106.721V174.03H104.511V185.125H106.922ZM125.522 185.125V182.96H123.513C122.129 182.96 121.504 182.603 121.504 181.241V176.04H125.522V174.03H121.504V171.597H119.116V174.03H117.241V176.04H119.116V181.375C119.116 184.076 120.589 185.125 122.978 185.125H125.522ZM136.515 185.348C140.221 185.348 142.699 183.004 142.699 179.589C142.699 176.129 140.221 173.807 136.515 173.807C132.832 173.807 130.354 176.129 130.354 179.589C130.354 183.004 132.832 185.348 136.515 185.348ZM136.515 183.205C133.837 183.205 132.721 181.933 132.721 179.589C132.721 177.223 133.837 175.928 136.515 175.928C139.217 175.928 140.333 177.223 140.333 179.589C140.333 181.933 139.217 183.205 136.515 183.205ZM147.708 185.125V176.04H151.681V174.03H147.663C147.529 172.423 148.444 171.954 150.208 171.954H151.681V170.169H150.587C147.44 170.169 145.587 171.597 145.319 174.03H143.623V176.04H145.297V185.125H147.708ZM162.077 185.348C165.202 185.348 167.256 184.12 167.256 182.044C167.256 180.214 166.05 179.321 163.416 178.986L160.849 178.629C159.175 178.406 158.728 178.093 158.728 177.223C158.728 176.173 159.443 175.727 161.474 175.727C163.929 175.727 164.599 176.419 164.599 177.736V177.87H166.988V177.803C166.988 175.169 164.934 173.807 161.541 173.807C158.125 173.807 156.362 175.191 156.362 177.133C156.362 178.986 157.634 179.879 159.733 180.147L162.769 180.549C164.354 180.772 164.889 181.062 164.889 181.977C164.889 182.96 164.242 183.406 162.077 183.406C159.755 183.406 158.884 182.937 158.884 181.486V181.308H156.474V181.375C156.474 183.942 158.505 185.348 162.077 185.348ZM172.254 185.348C174.777 185.348 176.54 184.232 177.121 182.357H177.277V185.125H179.487V178.383C179.487 175.727 177.902 173.807 174.375 173.807C170.848 173.807 168.749 175.705 168.749 178.227V178.317H171.138V178.227C171.138 176.598 172.143 175.928 174.196 175.928C176.317 175.928 177.121 176.575 177.121 178.406V179.053L172.076 179.589C169.888 179.834 168.504 180.727 168.504 182.446C168.504 184.277 169.955 185.348 172.254 185.348ZM170.915 182.29C170.915 181.419 171.518 181.129 172.768 180.973L177.121 180.482C177.121 182.669 175.424 183.607 172.902 183.607C171.518 183.607 170.915 183.183 170.915 182.29ZM184.05 185.125V170.169H181.639V185.125H184.05ZM191.863 185.348C195.167 185.348 197.488 183.719 197.488 181.352V181.152H195.077V181.33C195.077 182.647 194.118 183.406 191.796 183.406C189.229 183.406 188.18 182.268 188.09 180.125H197.511C197.578 179.79 197.6 179.477 197.6 179.075C197.6 175.705 195.256 173.807 191.818 173.807C188.202 173.807 185.836 176.129 185.836 179.589C185.836 183.295 188.224 185.348 191.863 185.348ZM191.774 175.705C194.14 175.705 195.323 176.687 195.323 178.741V178.785H188.113C188.247 176.799 189.318 175.705 191.774 175.705ZM24.3934 212.125V209.96H22.3844C21.0003 209.96 20.3753 209.603 20.3753 208.241V203.04H24.3934V201.03H20.3753V198.597H17.9867V201.03H16.1116V203.04H17.9867V208.375C17.9867 211.076 19.4601 212.125 21.8486 212.125H24.3934ZM31.4822 212.348C34.786 212.348 37.1076 210.719 37.1076 208.352V208.152H34.6967V208.33C34.6967 209.647 33.7368 210.406 31.4152 210.406C28.8481 210.406 27.7989 209.268 27.7096 207.125H37.1299C37.1969 206.79 37.2192 206.477 37.2192 206.075C37.2192 202.705 34.8753 200.807 31.4375 200.807C27.8212 200.807 25.455 203.129 25.455 206.589C25.455 210.295 27.8435 212.348 31.4822 212.348ZM31.3929 202.705C33.7591 202.705 34.9422 203.687 34.9422 205.741V205.785H27.7319C27.8659 203.799 28.9374 202.705 31.3929 202.705ZM41.4358 212.125V205.897C41.4358 203.91 42.2171 202.861 44.1145 202.861C45.7664 202.861 46.4361 203.598 46.4361 205.183V206.165H48.8247V204.714C48.8247 202.615 47.7308 200.807 45.2084 200.807C42.9314 200.807 41.726 202.236 41.3911 204.022H41.2349V201.03H39.0249V212.125H41.4358ZM52.7498 212.125V206.634C52.7498 204.178 53.5758 202.973 55.9644 202.973C58.1074 202.973 58.9556 203.91 58.9556 206.098V212.125H61.3442V206.634C61.3442 204.178 62.1925 202.973 64.5587 202.973C66.7017 202.973 67.5723 203.91 67.5723 206.098V212.125H69.9608V205.45C69.9608 202.772 68.5099 200.807 65.6302 200.807C62.8175 200.807 61.5674 202.571 61.2772 204.468H61.1433C60.8308 202.348 59.4691 200.807 56.9466 200.807C54.1785 200.807 52.9731 202.526 52.6829 204.379H52.5489V201.03H50.339V212.125H52.7498ZM74.5278 199.736V197.169H72.1169V199.736H74.5278ZM74.5278 212.125V201.03H72.1169V212.125H74.5278ZM79.1711 212.125V206.634C79.1711 204.223 80.265 202.973 82.6982 202.973C84.9974 202.973 85.935 204.022 85.935 206.098V212.125H88.3459V205.45C88.3459 202.883 86.8279 200.807 83.7474 200.807C80.9347 200.807 79.4613 202.593 79.1265 204.468H78.9702V201.03H76.7603V212.125H79.1711ZM93.7533 212.348C96.2758 212.348 98.0393 211.232 98.6197 209.357H98.7759V212.125H100.986V205.383C100.986 202.727 99.401 200.807 95.8739 200.807C92.3469 200.807 90.2486 202.705 90.2486 205.227V205.317H92.6371V205.227C92.6371 203.598 93.6417 202.928 95.6954 202.928C97.816 202.928 98.6197 203.575 98.6197 205.406V206.053L93.5747 206.589C91.387 206.834 90.003 207.727 90.003 209.446C90.003 211.277 91.454 212.348 93.7533 212.348ZM92.4139 209.29C92.4139 208.419 93.0166 208.129 94.2667 207.973L98.6197 207.482C98.6197 209.669 96.9231 210.607 94.4006 210.607C93.0166 210.607 92.4139 210.183 92.4139 209.29ZM105.549 212.125V197.169H103.138V212.125H105.549Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6720",
    x1: 19.4661,
    y1: 182.688,
    x2: 19.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6720",
    x1: 54.4661,
    y1: 182.688,
    x2: 54.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6720",
    x1: 90.4661,
    y1: 182.688,
    x2: 90.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6720",
    x1: 126.466,
    y1: 182.688,
    x2: 126.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6720",
    x1: 162.466,
    y1: 182.688,
    x2: 162.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6720",
    x1: 197.466,
    y1: 182.688,
    x2: 197.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6720",
    x1: 233.466,
    y1: 182.688,
    x2: 233.466,
    y2: 48.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6720",
    x1: 269.17,
    y1: 18.9539,
    x2: -9.24119,
    y2: 18.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6720",
    x1: 269.17,
    y1: 77.9539,
    x2: -9.24119,
    y2: 77.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6720",
    x1: 269.17,
    y1: 47.9539,
    x2: -9.24119,
    y2: 47.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6720",
    x1: 60,
    y1: 16.125,
    x2: 62.6601,
    y2: 133.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508459,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6720",
    x1: 60,
    y1: 16.125,
    x2: 60,
    y2: 104.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6720"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_6720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 39.125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_75_6720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4655,
    height: 41.5,
    fill: "white",
    transform: "translate(49 39.125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbusiness2);
export default __webpack_public_path__ + "static/media/bigbusiness2.0d7a6285876214ae5914fcdd43a1e664.svg";
export { ForwardRef as ReactComponent };